import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppStorage } from './appStorage.service';
import { ENDPOINTS } from '../constants/app-values';
import { Fechas } from '../constants/diasHabiles';

@Injectable({
  providedIn: 'root'
})
export class FechaService {
  constructor(private httpClient: HttpClient, private appStorage: AppStorage) {}

  getFechaMaxima(habil: boolean, dia: number, anno, mes): Date {
    if (habil) {
      return this.getFechaDiaHabil(dia, anno, mes);
    } else {
      return new Date(anno, mes, dia);
    }
  }

  getFechaDiaHabil(dia: number, anno, mes) {
    const maxDiaMes = new Date(anno, mes + 1, 0).getDate();

    let fechaAux = new Date(anno, mes, 1);
    let j = 0;

    for (let i = 1; i <= maxDiaMes && j < dia; i++) {
      if (this.esDiaHabil(i, anno, mes)) {
        fechaAux = new Date(anno, mes, i);
        j++;
      }
    }

    return fechaAux;
  }

  esDiaHabil(dia: number, anno, mes) {
    const dateTmp = new Date(anno, mes, dia);

    // Sab o Dom
    if (dateTmp.getDay() === 0 || dateTmp.getDay() === 6) {
      return false;
    }

    for (const date of Fechas.getHabiles()) {
      const dateI = new Date(date.fecha);
      if (this.sonDiasIguales(dateTmp, dateI)) {
        return false;
      }
    }

    return true;
  }

  sonDiasIguales(date1: Date, date2: Date) {
    return (
      date1.getDay() === date2.getDay() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }
}
